import React from 'react';
import { Accordion, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const FAQ: React.FC = () => (
  <>
    <h5 className="spacer">DÚVIDAS FREQUENTES</h5>

    <p>
      A sua dúvida pode ser a mesma de outras pessoas, por isso, disponibilizamos abaixo as mais frequentes para que você possa sanar a sua facilmente! Caso você não encontre o seu questionamento, entre em contato com o nosso setor comercial ligando para 51 3213 1338 ou enviando e-mail para comercial@jornaldocomercio.com.br.
    </p>

    <div className="spacer" />

    <Accordion>
      <Card>
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey="0">
            Como faço o credenciamento?
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body>
            Para se credenciar, basta acessar a página de credenciamento (
            <span style={{textDecoration: 'line-through'}}>clicando aqui</span>
            {' '}
            - recurso temporariamente indisponível),
            e assim verificar em qual tipo a sua empresa se encaixa. Você primeiro passará por uma análise, após a verificação, você poderá continuar utilizando a plataforma.
            A aprovação ou rejeição é informada por e-mail.
          </Card.Body>
        </Accordion.Collapse>
      </Card>
      <Card>
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey="1">
            Pode ser pessoa física, pessoa jurídica ou agência?
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="1">
          <Card.Body>
            Sim, porém todos os credenciamentos estão sujeitos a pré aprovação.
          </Card.Body>
        </Accordion.Collapse>
      </Card>
      <Card>
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey="2">
            Como devo formatar o conteúdo a ser publicado?
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="2">
          <Card.Body>
            A matéria deverá ser publicada de acordo com as normas para publicação do Jornal do Comércio. Para verificar as normas para publicar uma matéria
            {' '}
            <Link to="/standards">clique aqui</Link>
            .
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  </>
);

export default FAQ;
